<div class="modal-header">
  <h4 class="modal-title pull-left">{{modalHeading}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModel($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body padding30  modal-scroll-body">
  <h4 class="Offmarket-MainHeading">{{modalType==2?'List as Off-Market':'Add Pricing'}}</h4>
  <div class="form-group margin-top-20 margin-bottom-40">
    <label class="form-label clearfix">
      Property
    </label>
    <h6 class="quick-edit-heading form-control">{{(model.DisplayName!=null?model.DisplayName : model.TenantName)+' | ' +(propertyBasicDetails!=null&&propertyBasicDetails.City!=null?(propertyBasicDetails.City+', '):'')+(propertyBasicDetails!=null&&propertyBasicDetails.State!=null?(propertyBasicDetails.State):'')}}</h6>
  </div>
  <h5 class="mainhead">
    <span class="text Offmarket-pricing">
      Pricing Info
    </span>
  </h5>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group margin-top-10">
        <!--<div class="rightcheckbox">
          <label class="custom-checkbox margin-right-15 margin-bottom-15" for="checkbox18">
            <input readonly="readonly" id="chkUnpriced" (click)="UnpricedClick($event)" [(ngModel)]="model.Unpriced" id="checkbox18" type="checkbox"> Unpriced
            <i></i>
          </label>
        </div>-->
        <label class="form-label">
          Asking Price
          <span class="star">*</span>
          <label *ngIf="model.IsPortfolio" class="custom-checkbox " style="float:right; height:10px" for="chkCalcAskingPrice">
            <input #inputCalcAskingPrice id="chkCalcAskingPrice" (click)="autoCalcAskingPrice(inputCalcAskingPrice.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPrice"> Auto Calc
            <i></i>
          </label>
        </label>
        <div class="textbox-with-btn-left" *ngIf="!model.Unpriced">
          <input txtAskingPrice="ngModel" [attr.disabled]="(modalType==2) ? 'disabled' : null" dropSpecialCharacters="false" maxlength="18" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  [(ngModel)]="model.Price"
                 class="form-control " value="{{model.Price|number}}" (keyup)="updateCapRate()">
          <span class="leftlabel">$</span>
        </div>
        <div *ngIf="model.Unpriced">
          <input type="text" disabled [(ngModel)]="model.UnpricedText"
                 class="form-control">
        </div>
        <div>
          <p class="redtext">
            {{askingPriceText}}
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group  margin-top-10">
        <label class="form-label">
          {{capratetext}}
          <span class="star">*</span>
          <!--<label class="custom-checkbox " for="checkbox12" style="float:right; height:10px" for="chkCalcCAP">
    <input [attr.disabled]="(disableCapRate||modalType==2) ? 'disabled' : null" #inputCalcCAP id="chkCalcCAP" (click)="reCalcRates(inputCalcCAP.checked)" type="checkbox" [(ngModel)]="model.AutoCalcCapRate"> Auto Calc Cap Rate
    <i></i>
  </label>-->
        </label>
        <div class="textbox-with-btn textbox-with-2character" *ngIf="!model.Unpriced">
          <input [attr.disabled]="(disableCapRate||modalType==2) ? 'disabled' : null" (keyup)="model.AutoCalcCapRate=false;validateCapRate()" type="text" mask="999.99" #txtCapRate="ngModel" [dropSpecialCharacters]="false" [(ngModel)]="model.CapRate" class="form-control" (change)="validationService.onlyDecimal($event); validateCapRate(); reCalcAskingPrice();">
          <span class="rightlabel">%</span>
        </div>
        <div *ngIf="model.Unpriced">
          <input type="text" disabled [(ngModel)]="model.UnpricedText"
                 class="form-control">
        </div>
        <div>
          <p class="redtext">
            {{capRateMessage}}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="form-group">
        <label class="form-label">Sale Notes</label>
        <textarea [attr.disabled]="(disableCapRate||modalType==2) ? 'disabled' : null" [(ngModel)]="model.SalesNotes"
                  class="form-control property-description" maxlength="200"
                  rows="3"></textarea>
      </div>
    </div>
  </div>
  <div *ngIf="propertyBasicDetails!=null&&propertyBasicDetails.Guid!=null&&propertyBasicDetails.Guid!=''&&modalType==2">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <h6 class="displayvalue quick-edit-heading">{{propertyBasicDetails!=null&&propertyBasicDetails.TenantName!=null?propertyBasicDetails.TenantName:'-'}}</h6>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <h6 class="quick-edit-heading2">{{propertyBasicDetails!=null&&propertyBasicDetails.Address!=null?propertyBasicDetails.Address:'-'}}</h6>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="blocklabel">Lease Structure</label>
          <h6 class="displayvalue">{{propertyBasicDetails!=null&&propertyBasicDetails.LeaseStructure!=null?propertyBasicDetails.LeaseStructure:'-'}}</h6>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="blocklabel">Ownership Type</label>
          <h6 class="displayvalue">{{(propertyBasicDetails!=null&&propertyBasicDetails.OwnershipType!=null)?propertyBasicDetails.OwnershipType:'-'}}</h6>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="blocklabel">Net Operting Income</label>
          <h6 class="displayvalue">{{(propertyBasicDetails!=null&&propertyBasicDetails.RentNOI!=null)?('$ ' + validationService.decimalCommaFormat(propertyBasicDetails.RentNOI)):'-'}}</h6>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="blocklabel">Remaining Term</label>
          <h6 class="displayvalue">{{(propertyBasicDetails!=null&&propertyBasicDetails.Remaining_Term!=null&&propertyBasicDetails.Remaining_Term!=undefined)?propertyBasicDetails.Remaining_Term:'-'}}</h6>
        </div>
      </div>
    </div>
  </div>
  <h5 *ngIf="modalType==2" class="displayvalue margin-bottom-15" style="font-weight: 700;color:#053D5D">Once submitted, contact your broker to make any changes.</h5>
  <div class="text-right margin-top-20">
    <div class="margin-bottom-10 text-right">
      <button (click)="ProccedToSave()" *ngIf="modalType==1" class="btn btn-addgreen btn-lg margin-right-5">PROCEED</button>
      <button (click)="BackToSave()" *ngIf="modalType==2" style="font-weight: 700;" class="btn btn-lg margin-right-5 portfolio-back">< Back</button>
      <button (click)="SaveProperty(2)" *ngIf="modalType==2" class="btn btn-addgreen btn-lg margin-right-5">LIST AS OFF-MARKET</button>
    </div>
  </div>
</div>



